import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "refresh",
  "use": "refresh-usage",
  "viewBox": "0 0 16 19",
  "content": "<symbol viewBox=\"0 0 16 19\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"refresh\">\n    <path d=\"M7.5 1.08304L11 4.58304L7.5 8.08304M15 10.9997C15 14.8657 11.866 17.9997 8 17.9997C4.13401 17.9997 1 14.8657 1 10.9997C1 7.13368 4.13401 3.99967 8 3.99967C8.81815 3.99967 9.75 3.99967 10.9167 4.58301\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol